'use client';

import { useEffect, useMemo, useState } from 'react';
import { usePathname, useSelectedLayoutSegments } from 'next/navigation';
import { isPriceGuideRoute } from '@/domains/paydirt/nav';

/**
 * Price guide detection for chrome (nav/footer/sidebar).
 * usePathname alone is wrong during static export prerender of the root layout;
 * layout segments and window.location cover materials routes reliably.
 */
export function useIsPriceGuideRoute(): boolean {
  const pathname = usePathname() ?? '/';
  const segments = useSelectedLayoutSegments();
  const [browserPath, setBrowserPath] = useState<string | null>(null);

  useEffect(() => {
    setBrowserPath(window.location.pathname);
  }, [pathname]);

  return useMemo(() => {
    if (segments[0] === 'materials') return true;
    const path = browserPath ?? pathname;
    return isPriceGuideRoute(path);
  }, [segments, browserPath, pathname]);
}
